module.exports = __webpack_public_path__ + "img/sela-logo-tag.5a7c51ca.svg";